import { api } from '../client';
import type { AuthState, VendorAuthState } from '../../types/common';

export const authApi = {
  login: (username: string, password: string) =>
    api.post<{ success: boolean; user: AuthState['user']; permissions: string[]; error?: string }>(
      '/api/auth/login', { username, password }
    ),

  logout: () =>
    api.post<{ success: boolean }>('/api/auth/logout'),

  me: () =>
    api.get<AuthState>('/api/auth/me'),

  changePassword: (currentPassword: string, newPassword: string) =>
    api.put<{ success: boolean; message?: string; error?: string }>(
      '/api/auth/change-password', { currentPassword, newPassword }
    ),
};

export const vendorAuthApi = {
  login: (username: string, password: string) =>
    api.post<{ success: boolean; vendor: VendorAuthState['vendor']; error?: string }>(
      '/vendor/api/auth/login', { username, password }
    ),

  logout: () =>
    api.post<{ success: boolean }>('/vendor/api/auth/logout'),

  me: () =>
    api.get<VendorAuthState>('/vendor/api/auth/me'),
};
